import { render, staticRenderFns } from "./Wap_YSY001_Produce.vue?vue&type=template&id=4ebc3ba9&scoped=true&"
import script from "./Wap_YSY001_Produce.vue?vue&type=script&lang=js&"
export * from "./Wap_YSY001_Produce.vue?vue&type=script&lang=js&"
import style0 from "./Wap_YSY001_Produce.vue?vue&type=style&index=0&id=4ebc3ba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebc3ba9",
  null
  
)

export default component.exports